import { ValueGetterParams } from '@ag-grid-community/core';
import { OrderCardState, OrderModel } from '../model/order.model';

export const getOrderStatus = (value: ValueGetterParams): string => {
  return "ORDERS.STATUS." + value.data.status;
}

export const getOrderType = (value: ValueGetterParams): string => {
  return "ORDERS.TYPE." + value.data.dataType;
}

export const getCardState = (state: OrderCardState): string => {
  if (!state) {
    return '';
  }

  return "ORDERS.CARD_STATES." + state;
}

export const canCancelOrder = (order: OrderModel, isAuthor: boolean): boolean => {
  return order.status === 'DRAFT' && isAuthor && order.source === 'ENPROM';
}

export const arraysAreEqual = (arr1: number[], arr2: number[]): boolean => {
  if (arr1.length !== arr2.length) {
    return false;
  }

  const sortedArr1 = [...arr1].sort((a, b) => a - b);
  const sortedArr2 = [...arr2].sort((a, b) => a - b);
  return sortedArr1.every((value, index) => value === sortedArr2[index]);
}
